
import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import { compostionDetail } from '../api';
import moment from 'moment';
Vue.use(List);
@Component
export default class Detail extends Vue {
  ads = [];
  detail: any = {};
  button: boolean = true;
  votes: number = 0;
  gradeTextContent: any = [];
  student: any = '';
  school: any = '';
  class: any = '';
  teacher: any = '';
  content: any = '';
  grade = [
    {
      text: '一年级',
      value: 1,
    },
    {
      text: '二年级',
      value: 2,
    },
    {
      text: '三年级',
      value: 3,
    },
    {
      text: '四年级',
      value: 4,
    },
    {
      text: '五年级',
      value: 5,
    },
    {
      text: '六年级',
      value: 6,
    },
    {
      text: '初一',
      value: 7,
    },
    {
      text: '初二',
      value: 8,
    },
    {
      text: '初三',
      value: 9,
    },
    {
      text: '高一',
      value: 10,
    },
    {
      text: '高二',
      value: 11,
    },
    {
      text: '高三',
      value: 12,
    },
    {
      text: '专科',
      value: 16,
    },
    {
      text: '本科',
      value: 17,
    },
    {
      text: '硕士研究生',
      value: 18,
    },
    {
      text: '博士研究生',
      value: 19,
    },
  ];
  
  gradeText() {
    const num =
      this.detail &&
      this.detail.compositionData &&
      this.detail.compositionData.grade;

    return this.grade.find((item) => item.value === +num);
  }
  async created() {
    this.getDetail();
  }
  async getDetail() {
    const ret = await compostionDetail(this.$route.query.id as string);
    this.detail = ret.data;
    this.votes = ret.data.vote_num;
    this.gradeTextContent = this.gradeText();
  }
  formatDate(time: string) {
    return moment(time).format('YYYY-MM-DD HH:mm:ss');
  }
  intoTwo(){
    this.$router.push(`ruleTwo`);
  }
}
